import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

export const presetColors = [
  '#FFCBCB',
  '#FFE3CB',
  '#FF7979',
  '#FDA066',
  '#FDFFCB',
  '#D0EACC',
  '#695925',
  '#0F4103',
  '#BFEDDA',
  '#B0F1F4',
  '#034133',
  '#033341',
  '#93A4FF',
  '#D2ACFF',
  '#270341',
  '#410327',
  '#FFFFFF',
  '#BFBFBF',
  '#414141',
  '#000000',
];

@Component({
  selector: 'mj-color-picker',
  templateUrl: './mj-color-picker.component.html',
})
export class MjColorPickerComponent implements AfterViewInit {
  @ViewChild('colorPickerContainer', { static: true })
  public colorPickerContainer;

  @Input() public presetColors = presetColors;
  @Input() public position: string = 'bottom';
  @Input() public colorShouldBeShown: { isOn: boolean };
  @Input() public width = 130;
  @Input() public height = 130;
  @Input() public background;
  @Input() public colorPicker;
  @Output() public SetColor = new EventEmitter();

  public onSetColor(e) {
    this.SetColor.emit(e);
  }

  public ngAfterViewInit() {
    // create and append toggle button with click listener to color picker
    const colorPicker = this.colorPickerContainer.nativeElement
      .nextElementSibling.firstChild;
    const button = document.createElement('div');
    button.classList.add('toggle-button');
    button.addEventListener('click', () => {
      colorPicker.classList.toggle('parameters-open');
    });
    colorPicker.appendChild(button);
  }

  onCancel(e) {
    this.colorShouldBeShown.isOn = false;
  }
}
